(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mfv-away-banner"] && !Shopify.designMode) return;
  try {
    
function initialiseMFVAway(){document.querySelectorAll('[data-mfv-away]').forEach(function(wrapper){if(wrapper.dataset.ready)return;wrapper.dataset.ready='true';const dialog=wrapper.querySelector('dialog');if(!dialog||typeof dialog.showModal!=='function')return;const key='mfv-away:'+dialog.dataset.return+':'+dialog.querySelector('.mfv-away-message').textContent;const remember=function(){try{sessionStorage.setItem(key,'seen')}catch(error){}};const open=function(){if(!dialog.open)dialog.showModal()};wrapper.querySelector('.mfv-away-open').addEventListener('click',open);dialog.querySelector('.mfv-away-close').addEventListener('click',function(){dialog.close()});dialog.querySelector('.mfv-away-continue').addEventListener('click',function(){dialog.close()});dialog.addEventListener('close',remember);dialog.querySelector('a').addEventListener('click',remember);let seen=false;try{seen=sessionStorage.getItem(key)==='seen'}catch(error){}if(!seen){remember();open()}})}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initialiseMFVAway)}else{initialiseMFVAway()}
document.addEventListener('shopify:section:load',initialiseMFVAway);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mfv-reviews"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const button=event.target.closest('.mfv-gallery-controls button');if(!button)return;const track=button.closest('.mfv-review-gallery').querySelector('.mfv-review-track');track.scrollBy({left:Number(button.dataset.direction)*track.clientWidth,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})});

  } catch(e) { console.error(e); }
})();
})();
